import { dcFactory } from '@deleteagency/dc';
import { isElement } from '@deleteagency/dom-helper';

class App {

    init() {
        dcFactory.init(document.body);
        this.initObserver()
    }

    initObserver = () => {
        const observer = new MutationObserver(this.handleComponents);
        const observedElement = document.querySelector('main');

        if (observedElement) {
            observer.observe(observedElement, {
                attributes: false,
                childList: true,
                subtree: true,
                characterData: false
            });
        }
    }

    handleComponents = (records) => {
        const combineElementsReduce = (result, nodes) => [...result, ...nodes];

        const recordsArray = [...records];

        const removedElements = recordsArray
            .map(record => [...record.removedNodes])
            .reduce(combineElementsReduce, [])
            .filter(isElement);

        const addedElements = recordsArray
            .map(record => [...record.addedNodes])
            .reduce(combineElementsReduce, [])
            .filter(isElement);

        removedElements.forEach(element => dcFactory.destroy(element));
        addedElements.forEach(element => dcFactory.init(element));
    }
}

const instance = new App();
export default instance;
